export default __webpack_public_path__ + "static/media/sportsbra-small-back.b6f9ce5d.jpg";